<template>
  <div class="e-base-select">
    <div class="relative">
      <select
        :id="id"
        v-model="selectValue"
        :required="required"
        :disabled="disabled"
        :aria-required="required"
        :aria-invalid="error"
        :aria-describedby="error ? `${id}-error` : undefined"
        :class="[
          'w-full h-12 px-4 pt-4 py-0 border rounded-lg bg-white text-black appearance-none cursor-pointer focus:outline-none transition-colors duration-200',
          error ? 'border-[#E72318] border-2' : 'border-[#B8B8B8]',
          disabled && 'cursor-not-allowed opacity-50',
        ]"
        @focus="handleFocus"
        @blur="handleBlur"
      >
        <option value="" disabled hidden></option>
        <slot> </slot>
      </select>

      <!-- resten av templaten oförändrad -->
      <div
        aria-hidden="true"
        class="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none"
      >
        <svg
          width="12"
          height="8"
          viewBox="0 0 12 8"
          fill="none"
          class="text-[#161616A6]"
        >
          <path
            d="M1 1.5L6 6.5L11 1.5"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>

      <label
        :for="id"
        :class="[
          'absolute left-[17px] text-[#161616A6] transition-all duration-200 pointer-events-none origin-left',
          hasValue || isFocused
            ? 'top-1.5 text-xs'
            : 'top-1/2 -translate-y-1/2 text-sm',
        ]"
      >
        {{ label }}{{ required ? '*' : '' }}
      </label>
    </div>

    <ElementsErrorMessage
      v-if="error && errorMessage"
      :id="`${id}-error`"
      class="mt-2"
      role="alert"
      aria-live="polite"
    >
      {{ errorMessage }}
    </ElementsErrorMessage>
  </div>
</template>
<script setup lang="ts">
interface Props {
  id: string
  label: string

  required?: boolean
  disabled?: boolean
  error?: boolean
  errorMessage?: string
  default?: string | number
}

const props = withDefaults(defineProps<Props>(), {
  required: false,
  disabled: false,
  error: false,
  errorMessage: '',
  default: '',
})

const selectValue = defineModel<string | number>({
  default: '',
})

const isFocused = ref(false)

const hasValue = computed(() => {
  return selectValue.value !== '' && selectValue.value != null
})

const handleFocus = () => {
  isFocused.value = true
}

const handleBlur = () => {
  isFocused.value = false
}

onMounted(async () => {
  await nextTick()
  if (!selectValue.value && props.default) {
    selectValue.value = props.default
  }
})
</script>
